module.exports = __webpack_public_path__ + "img/81.dd8756ce.png";